/**
 * The allowed keys for the settings
 */
export enum SettingKey {
  SYNC = 'sync',
  SYNC_NOTIFICATION = 'sync_notification',
  SESSION = 'session',
  PHONE = 'phone',
  LANGUAGE = 'language',
  VIDEO_SOURCE = 'videoSource',
}